import type { GridRenderCellParams } from "@mui/x-data-grid";
import Avatar from "@mui/material/Avatar";
import ImageIcon from '@mui/icons-material/Image';
import { useTypedSelector } from "hooks";
import { concat, when } from "util/support";
import { selectConstants } from "features/general/selectors";

const LogoUrl = <T extends unknown>({ value }: GridRenderCellParams<T>) => {
    const constants = useTypedSelector(selectConstants);

    return (
        <Avatar
            variant='square'
            src={when(
                value,
                () => concat([
                    constants.OpenBankingLogosDomain,
                    value
                ], { token: '' })
            )}
        >
            <ImageIcon />
        </Avatar>
    );
};

export default LogoUrl;
